import { checkForInputInteractions } from "../hide-header.js";
import $ from "cash-dom";

$(document).ready(function () {
  $("[data-acsb='trigger']").on("click", function () {
    var loaded = sessionStorage.getItem("acsb_loaded");
    if (loaded) {
      return;
    }
    sessionStorage.setItem("acsb_loaded", true);
    window.location.href = window.location.href + "#showacsb";
    document.location.reload();
  });

  $("form.autocomplete").on("submit", function (e) {
    if ($(this).find("input").val() == "") {
      e.preventDefault();
    }
  });

  const addressInputs = document.querySelectorAll(".address-input");
  if (addressInputs.length > 0) {
    function removeFocus() {
      this.value = "";
      this.removeEventListener("focusin", removeFocus);
    }
    addressInputs.forEach((input) => {
      input.addEventListener("focusin", removeFocus);
    });
  }

  $("input[type='password'][data-eye]").each(function (i) {
    var $this = $(this);

    $this.wrap(
      $("<div/>", {
        style: "position:relative",
      }),
    );
    $this.css({
      paddingRight: 60,
    });
    $this.after(
      $("<div/>", {
        html: "Show",
        class: "btn btn-primary btn-sm",
        id: "passeye-toggle-" + i,
        style:
          "position:absolute;right:10px;top:50%;transform:translate(0,-50%);-webkit-transform:translate(0,-50%);-o-transform:translate(0,-50%);padding: 2px 7px;font-size:12px;cursor:pointer;",
      }),
    );
    $this.after(
      $("<input/>", {
        type: "hidden",
        id: "passeye-" + i,
      }),
    );
    $this.on("keyup paste", function () {
      $("#passeye-" + i).val($(this).val());
    });
    $("#passeye-toggle-" + i).on("click", function () {
      if ($this.hasClass("show")) {
        $this.attr("type", "password");
        $this.removeClass("show");
        $(this).removeClass("btn-outline-primary");
      } else {
        $this.attr("type", "text");
        $this.val($("#passeye-" + i).val());
        $this.addClass("show");
        $(this).addClass("btn-outline-primary");
      }
    });
  });

  $(".more").on("click", function (e) {
    e.preventDefault();
    var text = $(this).text();
    $(this)
      .text(text == " See More..." ? " See Less..." : " See More...")
      .siblings(".complete")
      .toggleClass("is-hidden");
  });

  $(".monitor-street-card, .share-street-card").on("click", function () {
    $(this).toggleClass("active");
  });

  $(".card").on("click", function (e) {
    if (e && $(e.target).hasClass("prevent-redirect")) {
      return;
    }

    if ($(this).data("flow")) window.location.href = $(this).data("flow");
  });

  $(".menu-button").on("click", function () {
    $(".big-header-menu-mobile").removeClass("big-header-menu-mobile--closed");
    $(".big-header-menu-mobile").addClass("big-header-menu-mobile--open");
  });
  $(".get-started").on("click", function () {
    $(".big-header-menu-mobile").removeClass("big-header-menu-mobile--closed");
    $(".big-header-menu-mobile").addClass("big-header-menu-mobile--open");
  });
  $(".menu-button-scroll").on("click", function () {
    $(".big-header-menu-mobile").removeClass("big-header-menu-mobile--closed");
    $(".big-header-menu-mobile").addClass("big-header-menu-mobile--open");
  });
  $(".close-menu-button").on("click", function () {
    $(".big-header-menu-mobile").addClass("big-header-menu-mobile--closed");
    $(".big-header-menu-mobile").removeClass("big-header-menu-mobile--open");
  });

  const bigHeader = $(".big-header");
  const updateSidebarMargin = function () {
    $(".sidebar-widget-container").css("top", bigHeader.outerHeight() + 15);
  };

  updateSidebarMargin();
  window.addEventListener("scroll", () => {
    if (!window.matchMedia("(max-width: 767px)").matches) {
      updateSidebarMargin();
    }
  });
  checkForInputInteractions();

  function throttle(fn, wait) {
    let time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
  }
  function backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  window.addEventListener("scroll", throttle(scrollFunction, 50));
  function scrollFunction() {
    if (
      document.body.scrollTop > 670 ||
      document.documentElement.scrollTop > 670
    ) {
      $("#back-to-top-btn").show();
    } else {
      $("#back-to-top-btn").hide();
    }
  }
  $("#back-to-top-btn").on("click", backToTop);
  $(".nocta").on("click", (e) => {
    e.stopPropagation();
    var url = $(e.currentTarget).find(".card-title a").attr("href");
    if (url) {
      window.location.href = url;
    }
  });
  $("#agent-modal-tab").on("click", function () {
    toggleAgentModalActive(false);
  });

  $(".close").on("click", function () {
    toggleAgentModalActive(true);
  });
  $(".real-estate-agent-modal").on("click", function (event) {
    if (!$(event.target).closest(".modal-content").length)
      toggleAgentModalActive(true);
  });

  function toggleAgentModalActive(modalIsHidden) {
    const modalTab = $("#agent-modal-tab");
    if (modalIsHidden) modalTab.show();
    else modalTab.hide();
    $(".real-estate-agent-modal").toggleClass("active");
    $("body").toggleClass("no-scroll");
  }
});

// Header image hidden on scroll
const headerImageContainer = document.getElementById("header-image-container");
if (headerImageContainer) {
  window.addEventListener(
    "scroll",
    function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop === 0) {
        headerImageContainer.style.display = "block";
      } else {
        headerImageContainer.style.display = "none";
      }
    },
    false,
  );
}
